import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import router from './router'
import axios from "axios";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import store from './store'

Vue.use(ElementUI);
Vue.config.productionTip = false

Vue.prototype.$availLanguages = [
    {
        value: "en",
        text: "English",
    },
    {
        value: "hi",
        text: "हिन्दी",
    },
    {
        value: "bn",
        text: "বাংলা",
    },
];

Vue.prototype.$getLangName = (id) => {
    switch (id) {
        case "en":
            return "English";
        case "hi":
            return "हिन्दी (Hindi)";
        case "bn":
            return "বাংলা (Bengali)";
    }
    return "Unknown";
};

const axiosResponseHandler = (res) => {
    if (
        typeof res.data === "object" &&
        (res.data.error && res.data.error.code === "freelance/session-expired")
    ) {
        store.commit("setUser", null);
        return Promise.reject(new Error(res.data.error.message));
    }
    return res;
};

const axiosErrorHandler = (error) => {
    if (error.message === "Network Error") {
        Vue.prototype.$message.error("No Connection! Check Internet Connection");
    }
    return Promise.reject(error);
};

const getAxios = (Vue.prototype.$getAxios = () => {
    const config = {
        withCredentials: true,
        baseURL: "https://freelance-prod-u6mqfnusla-el.a.run.app",
    };
    const axioss = axios.create(config);
    axioss.interceptors.response.use(axiosResponseHandler, axiosErrorHandler);
    axioss.interceptors.request.use((request) => request, axiosErrorHandler);
    return axioss;
});
Vue.axios = Vue.prototype.$axios = axios;
Vue.http = Vue.prototype.$http = getAxios();
Vue.http2 = Vue.prototype.$http2 = axios.create({baseURL: "https://metadata.examgoalapis.com/v1/_admin"});
Vue.testHttp = Vue.prototype.$testHttp = axios.create({baseURL: "https://test.examgoalapis.com/v1/_admin"});
Vue.prototype.$resetAxios = () => {
    Vue.http = Vue.prototype.$http = getAxios();
};
Vue.prototype.$availCountries = [
    {
        value: "in",
        text: "India"
    }
];
Vue.directive('permission', (el, binding, vnode) => {
    const isGranted = () => {
        const perms = vnode.context.$store.state.user ? (Array.isArray(vnode.context.$store.state.user.permissions) ? vnode.context.$store.state.user.permissions : []) : []
        if (typeof binding.value === "string") return perms.indexOf(binding.value) >= 0
        if (Array.isArray(binding.value)) {
            for (const p of binding.value) {
                if (binding.arg === "any") {
                    if (perms.indexOf(p) >= 0) return true
                }
                if (perms.indexOf(p) < 0) return false
            }
        }
        return true
    }
    if (!isGranted()) {
        const comment = document.createComment(' ');
        Object.defineProperty(comment, 'setAttribute', {
            value: () => undefined,
        });
        vnode.elm = comment;
        vnode.text = ' ';
        vnode.isComment = true;
        vnode.context = undefined;
        vnode.tag = undefined;
        vnode.data.directives = undefined;
        if (vnode.componentInstance) vnode.componentInstance.$el = comment;
        if (el.parentNode) el.parentNode.replaceChild(comment, el);
    }
});

new Vue({
    vuetify,
    router,
    store,
    render: h => h(App)
}).$mount('#app')
